import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { CrearContratoComponent } from '../crear-contrato/crear-contrato.component';
import {LogContratosComponent} from '../../contrato/log-contratos/log-contratos.component';
import { ClientesService } from '../clientes.service';
import { ContratoService } from '../crear-contrato/contrato.service';
import { TablesService } from 'src/app/generico/tables/tables.service';
import { MensajeService } from 'src/app/generico/servicio/mensaje.service';

export interface Telefono {
  numero : string;
  posicion : string;
}
@Component({
  selector: 'app-crear-cliente',
  templateUrl: './crear-cliente.component.html',
  styleUrls: ['./crear-cliente.component.scss']
})
export class CrearClienteComponent implements OnInit{

  id_cliente = null;
  tipos_id : any ;
  addressForm = this.fb.group({
    txt_correo :  [null, [Validators.required, Validators.email]],
    txt_razon_social : [null, [Validators.required]],
    fk_tipo_identificacion : [null, [Validators.required]],
    num_identificacion : [null, [Validators.required]],
    num_telefono : [null, []],
    ind_activo :[true],
  });

  recurso : string = 'contratos/admincontrato';
  columns : any = ['numero','aplicacion', 'usuarios permitidos', 'tipo contrato', 'fecha inicio', 'fecha fin', 'acciones'];
  params  : any = {};
  nombre_tabla : string = 'contratos_activos';
  target ;
  telefonos : string[] = [];


  constructor(private fb: FormBuilder,
              public dialog: MatDialog,
              private cli_serv : ClientesService,
              private contrato_serv : ContratoService,
              private tb_ser : TablesService,
              private msg_serv : MensajeService) {}

  ngOnInit(): void {

    this.target = document.querySelector('#btn_crear_contrato');
    this.cli_serv.obtener_tipos_id().then(()=>{this.tipos_id = this.cli_serv.tipos_id});
    this.llenar_forma();
  }

  onSubmit() {

    if (!this.cli_serv.json_cliente){
      this.crear_cliente();
    }else{
      this.actualizar_cliente();
    }
  }

  crear_cliente(){
    let value = this.addressForm.value;
    let json_telefono : any = this.validar_telefono();
    value.ind_activo = value.ind_activo ? 1 : 0;

    if(!json_telefono){
      return;
    }
    delete value['num_telefono'];
    value['json_telefono'] = json_telefono;

    this.cli_serv
        .registrar_cliente(value)
        .then(
          ()=>{
            if (this.cli_serv.json_cliente){

              this.id_cliente = this.cli_serv.json_cliente.id_cliente;
            }
          }
        );
  }

  actualizar_cliente(){
    let value = this.addressForm.value;
    let json_telefono : any = this.validar_telefono();
    value.ind_activo = value.ind_activo ? 1 : 0;

    if(!json_telefono){
      return;
    }
    delete value['num_telefono'];
    value['json_telefono'] = json_telefono;

    this.cli_serv
        .actualizar_cliente(this.id_cliente,value);
  }

  @HostListener('edit_contrato')
  crearContrato() {

    let json_contrato = this.tb_ser.params_event?.contrato;
    this.contrato_serv.fec_fin_prorroga = null;
    this.contrato_serv.fec_inicio_prorroga = null;

    if (json_contrato){
      this.contrato_serv.json_contrato = json_contrato
    }


    const dialogRef = this.dialog.open(CrearContratoComponent, {
      width: '500px',
      height: '500px'
    });

    dialogRef.afterClosed()
             .subscribe(
               ()=>{

                this.contrato_serv.json_contrato = null;
                this.tb_ser.params_event = null;
                this.tb_ser.tablas[this.nombre_tabla].cargar_datos(this.params);

               }
             );
  }

  logContratos() {
    const dialogRef = this.dialog.open(LogContratosComponent, {
      /* width: '500px', */
      height: '500px'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.tb_ser.tablas[this.nombre_tabla].cargar_datos(this.params);
    })
  }

  llenar_forma(){
    let json_cliente = this.cli_serv.json_cliente;

    if (json_cliente){
      /**Parametros consulta tabla contratos activos */
      this.params['ind_activo'] = 1;
      this.params['fk_cliente'] = this.cli_serv.json_cliente.id_cliente;

      this.id_cliente = json_cliente.id_cliente;
      this.addressForm.get('txt_correo').setValue(json_cliente.txt_correo);
      this.addressForm.get('txt_razon_social').setValue(json_cliente.txt_razon_social);
      this.addressForm.get('fk_tipo_identificacion').setValue(json_cliente.fk_tipo_identificacion);
      this.addressForm.get('num_identificacion').setValue(json_cliente.num_identificacion);
      this.addressForm.get('ind_activo').setValue(json_cliente.ind_activo);
      //this.telefonos = json_cliente.json_telefono? json_cliente.json_telefono : [];

      if(json_cliente.json_telefono){
        Object.keys(json_cliente.json_telefono)
              .forEach(
                key =>{
                  this.telefonos.push(json_cliente.json_telefono[key])
                }
              )
      }

    }
  }

  /**
   * adicion un nuevo telefono al cliente.
   */
  add_telefono(){

    let numero = this.addressForm.get('num_telefono').value;
    let mensaje : string ;

    if (!numero ||numero.trim().length == 0){
      mensaje = 'Debe de ingresar un número telefónico.'
    }else if(this.telefonos.indexOf(numero) >= 0){
      mensaje = 'El número telefónico ya existe.'
    }

    if (mensaje){
      this.msg_serv.ver_mensaje(mensaje,'',this.msg_serv.TIPO_ERROR);
      return false;
    }

    this.telefonos.push(numero);
    this.addressForm.get('num_telefono').setValue('');
    return true;
  }

  remover_telelfono(num_telefono){

    if(this.telefonos.length == 1){
      this.msg_serv.ver_mensaje('El cliente debe tener al menos un número telefónico.','',this.msg_serv.TIPO_ERROR);
      return;
    }

    let index = this.telefonos.indexOf(num_telefono);
    this.telefonos.splice(index, 1);

  }

  /**
   * valida que el cliente tenga al meno un telefono
   */
  validar_telefono(){

    let json_telefono = {};
    let index= 1;
    if (!this.telefonos.length){
      if(!this.add_telefono()){
        return null;
      }
    }

    this.telefonos.forEach(
      item =>{
        json_telefono[index] = item;
        index ++;
      }
    )

    return json_telefono;
  }
}
